<script>
import { layoutComputed } from "@/state/helpers";

import Vertical from "./vertical";
import Horizontal from "./horizontal";
import TwoColumns from "./twocolumn";
import LayoutFull from "./LayoutFull";
import LayoutGuest from "./LayoutGuest";

export default {
    components: {
        Vertical,
        Horizontal,
        TwoColumns,
        LayoutFull,
        LayoutGuest,
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },
    mounted() {
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
    <div>
        <Vertical v-if="layoutType === 'vertical' || layoutType === 'semibox'" :layout="layoutType">
            <slot />
        </Vertical>

        <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
            <slot />
        </Horizontal>

        <TwoColumns v-if="layoutType === 'twocolumn'" :layout="layoutType">
            <slot />
        </TwoColumns>
        <LayoutFull v-if="layoutType === 'full'" :layout="layoutType">
            <slot />
        </LayoutFull>
        <LayoutGuest v-if="layoutType === 'guest'" :layout="layoutType">
            <slot />    
        </LayoutGuest>
        
    </div>
</template>
